export default "__VITE_ASSET__DIj_bSxV__"